import React from "react"

import Button from "components/Button"
import classes from "./FuwgFooter.module.scss"
import { useTranslation } from "react-i18next"

const FuwgFooter = props => {
  const {
    setTab,
    setFiles,
    selectedImages,
    originalFiles,
    maxNumberOfUploads
  } = props

  const [t] = useTranslation()

  const handleShowFiles = () => {
    setTab("files")

    setFiles(prev => {
      const files =
        Object.values(selectedImages).map(image => ({
          id: (Math.random() * 10000) | 0,
          isFile: false,
          edited: false,
          blob: null,
          name: image.name,
          size: image.size,
          url: image.url,
          type: image.type,
          uploadProgress: 0,
          uploadFailed: false
        }))

      const newFiles = [...prev, ...files]

      originalFiles.current = [...prev, ...files]

      return newFiles
    })
  }

  const numberOfSelects =
    Object.keys(selectedImages).length

  return (
    <div className={classes["footer"]}>
      <span className={classes["text"]}>
        {"تعداد_انتخاب_های_مانده"}:{" "}
        <b>{maxNumberOfUploads - numberOfSelects}</b>
      </span>
      <Button
        color="success"
        onClick={handleShowFiles}
      >
        {t("بعدی")}
      </Button>
    </div>
  )
}

export default FuwgFooter